import React from "react";
import { useTranslation } from "react-i18next";

function TraditionSection() {
  const { t } = useTranslation();

  return (
    <section className="pt-12 pb-12 bg-slate-50/50 dark:bg-slate-900 transition-colors" id="tradition-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("taolu_tradition.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
        </div>

        {/* Quote Card */}
        <div className="max-w-5xl mx-auto">
          <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-md p-8 md:p-12 transition-all duration-200 relative">
            {/* Decorative Line Above Quote */}
            <div className="flex items-center justify-center mb-6">
              <div className="flex-1 h-px bg-gradient-to-l from-slate-200 to-transparent dark:from-slate-700 dark:to-transparent"></div>
              <div className="mx-3 flex items-center justify-center gap-2">
                {/* Left Diamond - rotated square */}
                <svg
                  className="w-1.5 h-1.5 text-primary-light dark:text-primary-light opacity-60"
                  viewBox="0 0 8 8"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon points="4,0 8,4 4,8 0,4" />
                </svg>
                {/* Quote Left Icon */}
                <i className="fas fa-quote-left text-primary-light dark:text-primary-light text-2xl md:text-3xl opacity-70"></i>
                {/* Right Diamond - rotated square */}
                <svg
                  className="w-1.5 h-1.5 text-primary-light dark:text-primary-light opacity-60"
                  viewBox="0 0 8 8"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon points="4,0 8,4 4,8 0,4" />
                </svg>
              </div>
              <div className="flex-1 h-px bg-gradient-to-r from-slate-200 to-transparent dark:from-slate-700 dark:to-transparent"></div>
            </div>

            {/* Quote Text */}
            <blockquote className="text-center mb-8">
              <p className="text-primary dark:text-primary-light text-2xl md:text-3xl lg:text-4xl font-serif italic leading-relaxed">
                {t("taolu_tradition.quote")}
              </p>
            </blockquote>

            {/* Decorative Divider */}
            <div className="flex items-center justify-center mb-8">
              <div className="flex-1 h-px bg-gradient-to-l from-slate-300 to-transparent dark:from-slate-600 dark:to-transparent"></div>
              <div className="mx-4 flex items-center justify-center">
                {/* Pagelines Icon */}
                <i className="fa-brands fa-pagelines text-slate-400 dark:text-slate-500 text-lg"></i>
              </div>
              <div className="flex-1 h-px bg-gradient-to-r from-slate-300 to-transparent dark:from-slate-600 dark:to-transparent"></div>
            </div>

            {/* Explanation Text */}
            <p className="text-center text-slate-700 dark:text-slate-300 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
              {t("taolu_tradition.text")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TraditionSection;

